import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ReviewService } from 'src/app/services/common/review.service';

@Component({
  selector: 'app-review-contributors-model',
  templateUrl: './review-contributors-model.component.html',
  styleUrls: ['./review-contributors-model.component.scss']
})
export class ReviewContributorsModelComponent implements OnInit {

  @ViewChild('SelectAll') input: ElementRef<HTMLInputElement>;
  @Input() public Content: any;
  users: any[] = [];
  selectedAllItems: boolean = false;
  selectedUsers: any[] = [];
  previosselectedUsers: any[] = [];
  searchForm: UntypedFormGroup;
  module: string;
  ApplicationId: string;

  constructor(
    public modalRef: NgbActiveModal,    
    private reviewService: ReviewService
    ) { }

    ngOnInit( ) {   
      if(this.Content != null){
        this.module = this.Content.module;
        this.ApplicationId = this.Content.ApplicationId;
      }

      this.GetUsers();

      if (this.Content !== null) {
       // this.users = this.Content.users;
        this.previosselectedUsers = this.Content.selectedUser;       
      }         

      this.searchForm = new UntypedFormGroup({
        searchFilter: new UntypedFormControl('')
      });
    }

    GetUsers() {
      this.reviewService.GetUsers("api/Review/GetUsers?ApplicationID=" + this.ApplicationId + "&Module=" + this.module).subscribe((result: any) => {
        if (result) {          
          this.users = result;
          if(this.users != null){

            this.users.forEach((user) => {
              this.previosselectedUsers.forEach((suser) => {
                if(suser.UserID==user.UserID)
                user.isSelected = true;
              });
            });

            let selectedRecords = this.users.filter((record) => record.isSelected) ?? [];   
            if(selectedRecords?.length >= 1){
              selectedRecords.forEach(ele => {
                let index = this.users.findIndex(x=> x.UserID == ele.UserID);
                this.users.splice(index, 1);
               });                  
            } 

            if(this.users.length >= 1){
              this.selectedAllItems = selectedRecords?.length == this.users?.length ? true : false; 
            }

          }         
        }
      });
    }

    get form() {
      return this.searchForm.controls;
    }

    selectedUser(event: any, user: any): void {
      let isChecked: boolean = event.target.checked;
      user.IsSelected = isChecked;
      let selectedRecords = this.users.filter((record) => record.IsSelected) ?? [];   
      this.selectedAllItems = selectedRecords?.length == this.users?.length ? true : false;   
    }

    selectAll(event: any): void {
      let isChecked: boolean = event.target.checked;
        this.users.forEach((user) => {
          const userIndex = this.users.findIndex((userSelected) => userSelected.UserID === user.UserID);
          if(userIndex != -1) {
            user.isSelected = isChecked;
            const listIndex = this.selectedUsers.findIndex((selectedUser) => selectedUser.UserID === user.UserID);
            if(isChecked && listIndex == -1) {
              this.selectedUsers.push(user);
            } else if(!isChecked) {
              this.selectedUsers.splice(listIndex, 1);
            }
          }
        });
    } 

    collectSelectedUser(user: any, event: any, users: Array<any>) {
      let isChecked = event.target.checked;
      user.isSelected = isChecked;
  
      if(!isChecked) {
        let prodIndex = this.selectedUsers.findIndex((selectedUser:any) => selectedUser.UserID == user.UserID);
        this.selectedUsers.splice(prodIndex, 1);
        this.input.nativeElement.checked = false;
        return;
      }
  
      this.selectedUsers.push(user);
      let count: number = 0;
      users.forEach((ele) => {
        let isSelectedUser: number = this.selectedUsers.findIndex((selectedUser) => selectedUser.UserID == ele.UserID);
        if(isSelectedUser != -1) count = count + 1; 
      })
      if(count ==  users.length)  {
        this.input.nativeElement.checked = true;
      }
    }

    save(){
      this.modalRef.close(this.selectedUsers);
    }

    close(){      
      this.users.forEach(element => {
        let user = this.previosselectedUsers.find(x=> x.UserID == element.UserID);
        if(user != null ){
          user.isSelected = true;
        } else{
          element.isSelected = false;
        }
      });
      this.modalRef.dismiss(this.previosselectedUsers);
    }
}
